import Component from '../../js/lib/component';

const classList = {
  root: '.js-history-item',
  toggle: '.js-history-item-toggle',
  body: '.js-history-item-body'
};

export default class historyItem extends Component {
  init() {
    if (!this.$.root.is('.in-process')) {
      this.$.body.hide();
      this.state.open = false;
    } else {
      this.$.root.addClass('is-open');
    }
    this.$.root.addClass('is-inited');
  }
  events() {
    this.$.toggle.on('click', () => {
      if (!this.state.animate) {
        this[this.state.open ? 'close' : 'open']();
      }
    });
  }
  open() {
    this.state.animate = true;
    this.$.root.addClass('is-open');
    this.$.body.slideDown(300, () => {
      this.state.animate = false;
      this.state.open = true;
    });
  }
  close() {
    this.state.animate = true;
    this.$.root.removeClass('is-open');
    this.$.body.slideUp(300, () => {
      this.state.animate = false;
      this.state.open = false;
    });
  }
}

Component.mount(historyItem, {
  name: 'historyItem',
  classList,
  state: {
    animate: false,
    open: true
  }
});
